import { render, staticRenderFns } from "./NoteCliente.vue?vue&type=template&id=5e8fabc2&"
import script from "./NoteCliente.vue?vue&type=script&lang=js&"
export * from "./NoteCliente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports